import axios from "axios";
import { SET_ALERT } from "../alert"

export const SET_LOADING = 'SET_LOADING';
export const SET_CATEGORIES = 'SET_CATEGORIES';
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';

export default {
    state: {
        isLoading: false,
        categories: [],
        currentPage: 1,
    },
    mutations: {
        [SET_LOADING](state, loading) {
            state.isLoading = loading;
        },
        [SET_CATEGORIES](state, categories) {
            state.categories = categories;
        },
        [SET_CURRENT_PAGE](state, page) {
            state.currentPage = page;
        },
    },
    actions: {
        getCategories({ commit, state }) {
            commit(SET_LOADING, true);
            axios
                .get("api/categories?page=" + state.currentPage)
                .then((response) => {
                    commit(SET_LOADING, false);
                    commit(SET_CATEGORIES, response.data)
                })
                .catch((error) => {
                    commit(SET_LOADING, false);
                    if (error.response.data) {
                        commit(SET_ALERT, {
                            message: error.response.data.message,
                            type: 'error'
                        });
                    }
                });
        },

        getCategoriesAll({ commit }) {            
            axios
                .get("api/categories")
                .then((response) => {
                    commit(SET_CATEGORIES, response.data)
                })
                .catch((error) => {                    
                    if (error.response.data) {
                        commit(SET_ALERT, {
                            message: error.response.data.message,
                            type: 'error'
                        });
                    }
                });
        },

        createCategory({ commit, dispatch }, form) {
            commit(SET_LOADING, true);
            axios
                .post("api/categories", form)
                .then(() => {
                    commit(SET_LOADING, false);
                    commit(SET_ALERT, {
                        message: "Categoria creada correctamente",
                        type: 'success'
                    });
                    dispatch('getCategories');
                })
                .catch((error) => {
                    commit(SET_LOADING, false);
                    if (error.response.data) {
                        var message;
                        error.response.data.errors ?
                            message = error.response.data.errors[Object.keys(error.response.data.errors)[0]][0] :
                            message = error.response.data.message;

                        commit(SET_ALERT, {
                            message: message,
                            type: 'error'
                        })
                    }
                });
        },

        updateCategory({ commit, dispatch }, payload) {
            commit(SET_LOADING, true);
            axios
                .put("api/categories/" + payload.id, payload.form)
                .then(() => {
                    commit(SET_LOADING, false);
                    commit(SET_ALERT, {
                        message: "Categoria editada correctamente",
                        type: 'success'
                    });
                    dispatch('getCategories');
                })
                .catch((error) => {
                    commit(SET_LOADING, false);
                    if (error.response.data) {
                        commit(SET_ALERT, {
                            message: error.response.data.message,
                            type: 'error'
                        })
                    }
                });
        },

        deleteCategory({ commit, dispatch }, id) {
            commit(SET_LOADING, true);
            axios
                .delete("api/categories/" + id,)
                .then(() => {
                    commit(SET_LOADING, false);
                    commit(SET_ALERT, {
                        message: "Categoria eliminada correctamente",
                        type: 'success'
                    });
                    dispatch('getCategories');
                })
                .catch((error) => {
                    commit(SET_LOADING, false);
                    if (error.response.data) {
                        commit(SET_ALERT, {
                            message: error.response.data.message,
                            type: 'error'
                        })
                    }
                });
        },

        nextPageCategories({ commit, dispatch }, page) {
            commit(SET_CURRENT_PAGE, page);
            dispatch('getCategories');
        }
    },
};
